import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import SearchBar from './SearchBar';
import MobileMenu from './MobileMenu';

const Navbar = () => {

  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed w-full bg-black top-0 z-[1] h-[4rem] border-b border-gray-500 px-3 sm:px-4 md:px-8 lg:px-12 xl:px-16 2xl:px-20">
      <div className="relative flex h-16 items-center justify-between">
        <div className="flex items-center">
          <Link to="/">
            <img alt="Your Company" src={logo} className="h-[3rem] w-auto rotate-45" />
          </Link>
        </div>
        <div className="flex flex-1 items-center justify-center space-x-4 vsm:px-4">
          <SearchBar />
        </div>
        <div className="hidden sm:flex items-center space-x-4">
          <Link to="#" className="text-sm font-medium text-gray-300 hover:text-white">
            Sign Up
          </Link>
          <Link
            to="#"
            className="flex items-center justify-center text-sm font-medium bg-red-700 rounded-full w-24 h-10 hover:bg-red-800"
          >
            Log In
          </Link>
        </div>
        <MobileMenu isOpen={isOpen} setIsOpen={setIsOpen} />
      </div>
    </nav>
  );
};

export default Navbar;